import _defineProperty from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import React from "react";
var __jsx = React.createElement;
import compact from 'lodash/compact';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { Area, CartesianGrid, ComposedChart, Legend, Line, Tooltip, XAxis, YAxis } from 'recharts';
import { OptimizationContainer } from './YTGOptimizationLevels.style';

var roundNumber = function roundNumber(numberToRound) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var pow = Math.pow(10, Math.abs(Math.round(precision)));
  var m = Number((Math.abs(numberToRound) * pow).toPrecision(15));
  return Math.round(m) / pow * Math.sign(numberToRound);
};

var getOptimizationLabel = function getOptimizationLabel(intl, level) {
  return intl.formatMessage({
    id: "yourTextGuru.optimizationLevels.".concat(level)
  });
};

var YTGOptimizationLevels = function YTGOptimizationLevels(_ref) {
  var optimizationLevels = _ref.optimizationLevels;
  var intl = useIntl();
  var data = useMemo(function () {
    return compact(Object.keys(optimizationLevels).map(function (key) {
      var _ref2;

      var levels = optimizationLevels[key];

      if (levels === undefined) {
        return undefined;
      }

      return _ref2 = {
        name: key
      }, _defineProperty(_ref2, getOptimizationLabel(intl, 'blue'), levels.blue.map(function (num) {
        return roundNumber(num, 2);
      })), _defineProperty(_ref2, getOptimizationLabel(intl, 'green'), levels.green.map(function (num) {
        return roundNumber(num, 2);
      })), _defineProperty(_ref2, getOptimizationLabel(intl, 'orange'), levels.orange.map(function (num) {
        return roundNumber(num, 2);
      })), _defineProperty(_ref2, getOptimizationLabel(intl, 'red'), levels.red.map(function (num) {
        return roundNumber(num, 2);
      })), _defineProperty(_ref2, getOptimizationLabel(intl, 'score'), roundNumber(levels.score, 2)), _ref2;
    }));
  }, [intl, optimizationLevels]);
  return __jsx(React.Fragment, null, data.length > 0 ? __jsx(OptimizationContainer, null, __jsx(ComposedChart, {
    width: Math.max(726, data.length * 85),
    height: 400,
    data: data,
    margin: {
      top: 20,
      right: 0,
      bottom: 20,
      left: 0
    }
  }, __jsx(CartesianGrid, {
    stroke: "#f5f5f5"
  }), __jsx(XAxis, {
    label: {
      value: intl.formatMessage({
        id: 'yourTextGuru.labels.horizontal'
      }),
      position: 'bottom',
      offset: -5
    },
    dataKey: "name",
    angle: -60,
    tickMargin: 35,
    height: 100,
    scale: "band"
  }), __jsx(YAxis, {
    label: {
      value: intl.formatMessage({
        id: 'yourTextGuru.labels.vertical'
      }),
      angle: -90
    }
  }), __jsx(Tooltip, null), __jsx(Legend, {
    verticalAlign: "top"
  }), __jsx(Area, {
    type: "monotone",
    dataKey: getOptimizationLabel(intl, 'red'),
    stroke: "#ce2e2e",
    fill: "#ce2e2e"
  }), __jsx(Area, {
    type: "monotone",
    dataKey: getOptimizationLabel(intl, 'orange'),
    stroke: "#ff7300",
    fill: "#ff7300"
  }), __jsx(Area, {
    type: "monotone",
    dataKey: getOptimizationLabel(intl, 'green'),
    stroke: "#82ca9d",
    fill: "#82ca9d"
  }), __jsx(Area, {
    type: "monotone",
    dataKey: getOptimizationLabel(intl, 'blue'),
    stroke: "#5888ff",
    fill: "#5888ff"
  }), __jsx(Line, {
    type: "monotone",
    dataKey: getOptimizationLabel(intl, 'score'),
    stroke: "#000000"
  }))) : __jsx(React.Fragment, null));
};

export default YTGOptimizationLevels;